import React from "react";
import { Box } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import dot1 from "../src/assets/backgroundImage/dot1.svg";
import dot2 from "../src/assets/backgroundImage/dot2.svg";
import ring from "../src/assets/backgroundImage/ring.svg";
import circle from "../src/assets/backgroundImage/circle.svg";
import CircularProgress from "@mui/material/CircularProgress";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { CustomerProvider } from "./pages/Customer/CustomerContext";
import { ThemeModeProvider } from "./contexts/ThemeModeContext";
import SegmentCount from "./pages/Reports/SegmentCount/SegmentCount";
import imageReactangle from "../src/assets/backgroundImage/rectangle.svg";
import OfflineServiceList from "./pages/Transactions/OfflineService/OfflineServiceList";
import CreateOfflineService from "./pages/Transactions/OfflineService/CreateOfflineService";
import HajjPackageList from "./pages/Service/hajj/HajjPackage/HajjPackageList";
import CreateHajjPackage from "./pages/Service/hajj/HajjPackage/CreateHajjPackage";
import HajjPackageLedger from "./pages/Service/hajj/HajjPackage/HajjPackageLedger";

const Others = React.lazy(() => import("./pages/Others/Others"));

const GdsCommand = React.lazy(() =>
  import("./pages/Others/GdsTerminal/GdsCommand")
);

const AgentStatisticsReport = React.lazy(() =>
  import("./pages/Reports/AgentReport/AgentStatisticsReport")
);
const AgentListReport = React.lazy(() =>
  import("./pages/Reports/AgentReport/AgentListReport")
);
const AirlineReport = React.lazy(() =>
  import("./pages/Reports/AirlineReport/AirlineReport")
);

const VendorAirlineReport = React.lazy(() =>
  import("./pages/Reports/VendorAirlineReport/VendorAirlineReport")
);


const CreateVendor = React.lazy(() => import("./pages/Vendor/CreateVendor"));

const Login = React.lazy(() => import("./layouts/Login/Login"));

const VendorListTable = React.lazy(() =>
  import("./pages/Vendor/VendorListTable")
);

const VendorTableListFilter = React.lazy(() =>
  import("./pages/Vendor/VendorListTableFilter")
);

const DashboardSidebar = React.lazy(() =>
  import("./components/DashboardSidebar/DashboardSidebar")
);

const AdminDashboard = React.lazy(() =>
  import("./pages/AdminDashboard/AdminDashboard")
);

const CreateCustomer = React.lazy(() =>
  import("./pages/Customer/CreateCustomer")
);
const CreateAdm = React.lazy(() =>
  import("./pages/Users/AdmManagement/CreateAdm")
);
const AdmList = React.lazy(() => import("./pages/Users/AdmManagement/AdmList"));

const CreateAgent = React.lazy(() => import("./pages/Agent/CreateAgent"));

const VendorNav = React.lazy(() => import("./pages/Vendor/VendorNav"));

const AgentNav = React.lazy(() => import("./pages/Agent/AgentNav"));

const VendorBasicInfo = React.lazy(() =>
  import("./pages/Vendor/VendorBasicInfo")
);
const AccountContactInfo = React.lazy(() =>
  import("./pages/Vendor/AccountContactInfo")
);

const VendorService = React.lazy(() => import("./pages/Vendor/VendorService"));

const AgentBasicInfo = React.lazy(() => import("./pages/Agent/AgentBasicInfo"));

const User = React.lazy(() => import("./pages/Users/User"));

const AgentDocuments = React.lazy(() => import("./pages/Agent/AgentDocuments"));

const AgentAccount = React.lazy(() => import("./pages/Agent/AgentAccount"));

const AgentRegister = React.lazy(() => import("./pages/Agent/AgentRegister"));

const FeatureAssign = React.lazy(() => import("./pages/Agent/FeatureAssign"));
const ApiAccessKey = React.lazy(() =>
  import("./pages/Agent/UserApi/ApiAccessKey")
);
const ApiAccessKeyList = React.lazy(() =>
  import("./pages/Agent/UserApi/ApiAccessKeyList")
);

const VendorAccount = React.lazy(() => import("./pages/Vendor/VendorAccount"));

const VendorContactInfo = React.lazy(() =>
  import("./pages/Vendor/VendorContactInfo")
);

const VendorRegister = React.lazy(() =>
  import("./pages/Vendor/VendorRegister")
);

const CustomerNav = React.lazy(() => import("./pages/Customer/CustomerNav"));

const CustomerBasicInfo = React.lazy(() =>
  import("./pages/Customer/CustomerBasicInfo")
);

const CustomerAccounts = React.lazy(() =>
  import("./pages/Customer/CustomerAccounts")
);

const CustomerRegister = React.lazy(() =>
  import("./pages/Customer/CustomerRegister")
);

const CustomerListTable = React.lazy(() =>
  import("./pages/Customer/CustomerListTable")
);

const Service = React.lazy(() => import("./pages/Service/Service"));

const Visa = React.lazy(() => import("./pages/Service/Visa/Visa"));
const VisaCategroyCreate = React.lazy(() =>
  import("./pages/Service/Visa/VisaCategroyCreate")
);
const VisaCategoryList = React.lazy(() =>
  import("./pages/Service/Visa/VisaCategroyList")
);

const VisaPackageCreate = React.lazy(() =>
  import("./pages/Service/Visa/VisaPackage/VisaPackageCreate")
);
const VisaFaqCreate = React.lazy(() =>
  import("./pages/Service/Visa/VisaFaq/VisaFaqCreate")
);

const VisaFaqList = React.lazy(() =>
  import("./pages/Service/Visa/VisaFaq/VisaFaqList")
);
const VisaPackageOrderCreate = React.lazy(() =>
  import("./pages/Service/Visa/VisaPackage/VisaPackageOrderCreate")
);
const VisaPackageOrderList = React.lazy(() =>
  import("./pages/Service/Visa/VisaPackage/VisaPackageOrderList")
);
const VisaPackageOrderDeatils = React.lazy(() =>
  import("./pages/Service/Visa/VisaPackage/VisaPackageOrderDetails")
);
const VisaUpdate = React.lazy(() =>
  import("./pages/Service/Visa/VisaUpdate/VisaUpdate")
);

const VisaPackageList = React.lazy(() =>
  import("./pages/Service/Visa/VisaPackage/VisaPackageList")
);

const Inventory = React.lazy(() => import("./pages/Invenrory/Inventory"));

const ProductCategoryCreate = React.lazy(() =>
  import("./pages/Invenrory/ProductCategories/ProductCategoryCreate")
);

const ProductCategoryList = React.lazy(() =>
  import("./pages/Invenrory/ProductCategories/ProductCategoryList")
);

const ProductsCreate = React.lazy(() =>
  import("./pages/Invenrory/Products/ProductsCreate")
);

const OrdersListTable = React.lazy(() =>
  import("./pages/Invenrory/Order/OrdersListTable")
);

const OrderDetails = React.lazy(() =>
  import("./pages/Invenrory/OrderDetails/OrderDetails")
);

const ApiOrderDetails = React.lazy(() =>
  import("./pages/Invenrory/ApiOrderDetails/ApiOrderDetails")
);

const ProductsList = React.lazy(() =>
  import("./pages/Invenrory/Products/ProductsList")
);

const PurchaseCreate = React.lazy(() =>
  import("./pages/Invenrory/Order/PurchaseCreate")
);

const PurchaseList = React.lazy(() =>
  import("./pages/Invenrory/Order/PurchaseList")
);

const SaleCreate = React.lazy(() =>
  import("./pages/Invenrory/Order/SaleCreate")
);

const SaleList = React.lazy(() => import("./pages/Invenrory/Order/SaleList"));

const QuotationCreate = React.lazy(() =>
  import("./pages/Invenrory/Order/QuotationCreate")
);

const QuotationList = React.lazy(() =>
  import("./pages/Invenrory/Order/QuotationList")
);

const SaleReturn = React.lazy(() =>
  import("./pages/Invenrory/Order/SaleReturnCreate")
);

const SaleReturnList = React.lazy(() =>
  import("./pages/Invenrory/Order/SaleReturnList")
);

const RemoteSale = React.lazy(() =>
  import("./pages/Invenrory/RemoteSale/RemoteSale")
);

const SuscriptionCreate = React.lazy(() =>
  import("./pages/Invenrory/Suscription/SuscriptionCreate")
);

const SuscriptionList = React.lazy(() =>
  import("./pages/Invenrory/Suscription/SuscriptionList")
);

const HotelCreate = React.lazy(() => import("./pages/Hotel/HotelCreate"));

const HotelListTable = React.lazy(() => import("./pages/Hotel/HotelListTable"));

const HotelDetails = React.lazy(() => import("./pages/Hotel/HotelDetails"));

const HotelBookingUpdate = React.lazy(() =>
  import("./pages/Hotel/HotelBookingUpdate/HotelBookingUpdate")
);

const AgentListTable = React.lazy(() => import("./pages/Agent/AgentListTable"));

const VendorDetail = React.lazy(() =>
  import("./pages/Vendor/VendorDetail/VendorDetail")
);

const AgentDetails = React.lazy(() =>
  import("./pages/Agent/AgentDetails/AgentDetails")
);

const PrivateRoute = React.lazy(() =>
  import("./components/PrivateRoute/PrivateRoute")
);

const CustomerDetails = React.lazy(() =>
  import("./pages/Customer/CustomerDetails/CustomerDetails")
);

const VendorBalanceNav = React.lazy(() =>
  import("./pages/Vendor/VendorAccount/VendorBalanceNav")
);

const CustomerAccountNav = React.lazy(() =>
  import("./pages/Customer/CustomerAccount/CustomerAccountNav")
);

const AgentAccountNav = React.lazy(() =>
  import("./pages/Agent/AgentAccount/AgentAccountNav")
);

const VendorAccountLedger = React.lazy(() =>
  import("./pages/Vendor/VendorLedger/VendorAccountLedger")
);

const CustomerAccountLedger = React.lazy(() =>
  import("./pages/Customer/CustomerLedger/CustomerAccountLedger")
);

const AgentAccountLedger = React.lazy(() =>
  import("./pages/Agent/AgentAccountLedger/AgentAccountLedger")
);

const AgentGaneralLedger = React.lazy(() =>
  import("./pages/Agent/AgentAccountLedger/AgentGaneralLedger")
);

const VendorBookingsDetailsChart = React.lazy(() =>
  import("./pages/Vendor/VendorBookingsDetails/VendorBookingsDetailsChart")
);

const VendorBookingListTable = React.lazy(() =>
  import("./pages/Vendor/VendorBookingsDetails/VendorBookingListTable")
);

const AgentBookingsDetailsChart = React.lazy(() =>
  import("./pages/Agent/AgentBookingsDetails/AgentBookingsDetailsChart")
);

const AgentBookingListTable = React.lazy(() =>
  import("./pages/Agent/AgentBookingsDetails/AgentBookingListTable")
);

const CustomerBookingsDetailsChart = React.lazy(() =>
  import(
    "./pages/Customer/CustomerBookingsDetails/CustomerBookingsDetailsChart"
  )
);

const CustomerBookingListTable = React.lazy(() =>
  import("./pages/Customer/CustomerBookingsDetails/CustomerBookingListTable")
);

const CompanyAccountNav = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyAccountNav")
);

const CompanyBalanceAdd = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyBalanceAdd")
);

const CompanyBalanceDeduct = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyBalanceDeduct")
);

const CompanyBalanceTransfer = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyBalanceTransFer")
);

const CreateCompanyAccount = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CreateCompanyAccount")
);

const CompanyBankListTable = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyBankListTable")
);

const ReceiptCopy = React.lazy(() =>
  import("./pages/Finance/ReceiptCopy/ReceiptCopy")
);

const CompanyExpenseTable = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyExpenseTable")
);

const VendorVoid = React.lazy(() =>
  import("./pages/Vendor/VendorBookingsTabs/VendorVoid")
);

const CurrencyList = React.lazy(() =>
  import("./pages/Settings/Currency/CurrencyList")
);

const CreateCurrency = React.lazy(() =>
  import("./pages/Settings/Currency/CreateCurrency")
);
const CurrencyChangeLogList = React.lazy(() =>
  import("./pages/Settings/Currency/CurrencyChangeLogList")
);

const Setting = React.lazy(() => import("./pages/Settings/Setting"));

const Profile = React.lazy(() => import("./pages/Profile/Profile"));

const TravellerCreate = React.lazy(() =>
  import("./pages/Others/Traveller/TravellerCreate")
);

const DepositRequestList = React.lazy(() =>
  import("./pages/Agent/DepositRequestList")
);

const CreateDepositRequest = React.lazy(() =>
  import("./pages/Agent/CreateDepositRequest")
);

const CreditManagementListTable = React.lazy(() =>
  import("./pages/Agent/CreditModule/CreditModuleNav")
);

const CreditRequestList = React.lazy(() =>
  import("./pages/Agent/CreditRequestList")
);

const CompanyAccountLedgerTable = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyAccountLedgerTable")
);
const CompanyCentralAccount = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyCentralAccount")
);
const CompanyCentralAccountInsights = React.lazy(() =>
  import("./pages/Company/CompanyAccount/CompanyCentralAccountInsights")
);

const TravellerListTable = React.lazy(() =>
  import("./pages/Others/Traveller/TravellerListTable ")
);

const BankChequeHistoryCreate = React.lazy(() =>
  import("./pages/Company/BankChequeHistory/BankChequeHistoryCreate")
);

const Promotion = React.lazy(() => import("./pages/Promotion/Promotion"));
const SmsTemplate = React.lazy(() =>
  import("./pages/Promotion/SmsTemplate/SmsTemplate")
);
const SmsTemplateList = React.lazy(() =>
  import("./pages/Promotion/SmsTemplate/TemplateSmsList")
);
const EmailTemplate = React.lazy(() =>
  import("./pages/Promotion/EmailTemplate/EmailTemplate")
);
const EmailTemplateList = React.lazy(() =>
  import("./pages/Promotion/EmailTemplate/EmailTemplateList")
);

const UserHotelMarkupCommissionList = React.lazy(() =>
  import("./pages/Market/UserHotelMarkup/UserHotelMarkupList")
);
const CreateUserHotelMarkupCommission = React.lazy(() =>
  import("./pages/Market/UserHotelMarkup/CreateUserHotelMarkup")
);
const ApiMarkupCommission = React.lazy(() =>
  import("./pages/Invenrory/ApiMarkupCommission/ApiMarkupCommission")
);
const ApiMarkupCommissionList = React.lazy(() =>
  import("./pages/Invenrory/ApiMarkupCommission/ApiMarkupCommissionList")
);
const UserMarkupCommissionList = React.lazy(() =>
  import("./pages/Market/UserFlightMarkup/UserFlightMarkupList")
);
const CreateUserMarkupCommission = React.lazy(() =>
  import("./pages/Market/UserFlightMarkup/CreateUserFlightMarkup")
);
const CreateAirlineBrandMarkupCommission = React.lazy(() =>
  import(
    "./pages/Market/AirlineBrandMarkupCommission/CreateAirlineBrandMarkupCommission"
  )
);
const AirlineBrandMarkupCommissionList = React.lazy(() =>
  import(
    "./pages/Market/AirlineBrandMarkupCommission/AirlineBrandMarkupCommissionList"
  )
);
const ChequeListTable = React.lazy(() =>
  import("./pages/Company/BankChequeHistory/ChequeListTable ")
);

const Transactions = React.lazy(() =>
  import("./pages/Company/Transactions/Transactions")
);

const CreateApiProvider = React.lazy(() =>
  import("./pages/Settings/ApiProvider/CreateApiProvider")
);

const ApiProviderList = React.lazy(() =>
  import("./pages/Settings/ApiProvider/ApiProviderList")
);

const VendorMarkupCommissionList = React.lazy(() =>
  import("./pages/Vendor/VendorMarkupCommission/VendorMarkupCommissionList")
);

const CreateVendorMarkupCommission = React.lazy(() =>
  import("./pages/Vendor/VendorMarkupCommission/CreateVendorMarkupCommission")
);

const UserLoginDeviceListTable = React.lazy(() =>
  import("./pages/Users/UserLoggedin/UserLoginDeviceListTable")
);

const UserActivityListTable = React.lazy(() =>
  import("./pages/Users/UserActivity/UserActivityListTable")
);

const UserLoginActivity = React.lazy(() =>
  import("./pages/Users/UserLoginActivity/UserLoginActivity")
);

const ResponsibilityListTable = React.lazy(() =>
  import("./pages/Users/Responsibility/Responsibility")
);

const AirlineBlockingList = React.lazy(() =>
  import("./pages/Settings/AirlineBlocking/AirlineBlockingList")
);

const CreateAirlineBlocking = React.lazy(() =>
  import("./pages/Settings/AirlineBlocking/CreateAirlineBlocking")
);

const PromoCodeList = React.lazy(() =>
  import("./pages/Settings/PromoCode/PromoCodeList")
);

const CreatePromoCode = React.lazy(() =>
  import("./pages/Settings/PromoCode/CreatePromoCode")
);

const AirlineRoutingCreate = React.lazy(() =>
  import("./pages/AirBooking/AirlineRouting/AirlineRoutingCreate")
);

const AirlineRoutinglist = React.lazy(() =>
  import("./pages/AirBooking/AirlineRouting/AirlineRoutinglist")
);

const Reports = React.lazy(() => import("./pages/Reports/Reports"));
const TotalSell = React.lazy(() =>
  import("./pages/Reports/TotalSell/TotalSell")
);

const ZoneReport = React.lazy(() =>
  import("./pages/Reports/ZoneReport/ZoneReport")
);

const AirBookingInfo = React.lazy(() =>
  import("./pages/AirBooking/AirBookingInfo")
);

const AirBookingDetails = React.lazy(() =>
  import("./pages/AirBooking/AirBookingDetails/AirBookingDetails")
);

const AirSearchLog = React.lazy(() =>
  import("./pages/AirBooking/AirSearchLog/AirSearchLog")
);

const DepartmentList = React.lazy(() =>
  import("./pages/HRM/Department/DepartmentList")
);

const CreateDepartment = React.lazy(() =>
  import("./pages/HRM/Department/CreateDepartment")
);

const DesignationList = React.lazy(() =>
  import("./pages/HRM/Designation/DesignationList")
);

const CreateDesignation = React.lazy(() =>
  import("./pages/HRM/Designation/CreateDesignation")
);

const EmployeeList = React.lazy(() =>
  import("./pages/HRM/Employee/EmployeeList")
);

const CreateEmployee = React.lazy(() =>
  import("./pages/HRM/Employee/CreateEmployee")
);

const AirBookingListTable = React.lazy(() =>
  import("./pages/AirBooking/AirBookingListTable")
);

const PassengerSegmentFlownStatus = React.lazy(() =>
  import("./pages/PassengerSegmentFlownStatus/PassengerSegmentFlownStatus")
);

const RoleList = React.lazy(() => import("./pages/IAM/Role/RoleList"));

const CreateRole = React.lazy(() => import("./pages/IAM/Role/CreateRole"));

const AirlineList = React.lazy(() =>
  import("./pages/Settings/Airline/AirlineList")
);

const CreateAirline = React.lazy(() =>
  import("./pages/Settings/Airline/CreateAirline")
);

const AirportList = React.lazy(() =>
  import("./pages/Settings/Airport/AirportList")
);

const CreateAirport = React.lazy(() =>
  import("./pages/Settings/Airport/CreateAirport")
);

const UserTaskList = React.lazy(() =>
  import("./pages/Users/UserTask/UserTaskList")
);

const UserTaskListMe = React.lazy(() =>
  import("./pages/Users/UserTask/UserTaskListMe")
);

const CreateUserTask = React.lazy(() =>
  import("./pages/Users/UserTask/CreateUserTask")
);

const UpdateUserTaskMe = React.lazy(() =>
  import("./pages/Users/UserTask/UpdateUserTaskMe")
);

const RefundSettlement = React.lazy(() =>
  import("./pages/AirBooking/Settlement/RefundSettlement")
);

const VoidSettlement = React.lazy(() =>
  import("./pages/AirBooking/Settlement/VoidSettlement")
);
const TicketSettlement = React.lazy(() =>
  import("./pages/AirBooking/Settlement/TicketSettlement")
);

const RefundDetail = React.lazy(() =>
  import("./pages/AirBooking/Details/RefundDetail")
);

const ReissueDetail = React.lazy(() =>
  import("./pages/AirBooking/Details/ReissueDetail")
);
const VendorChargeSection = React.lazy(() =>
  import("./pages/AirBooking/Details/VendorChargeSection")
);

const ReissueFareBreakdown = React.lazy(() =>
  import("./pages/AirBooking/Details/ReissueFareBreakdown")
);

const SsrDetail = React.lazy(() =>
  import("./pages/AirBooking/Details/SsrDetail")
);

const VoidDetail = React.lazy(() =>
  import("./pages/AirBooking/Details/VoidDetails")
);

const BookingDetailsUpdate = React.lazy(() =>
  import("./pages/AirBooking/BookingDetailsUpdate/BookingDetailsUpdate")
);

const AirBookingUpdate = React.lazy(() =>
  import("./pages/AirBooking/AirBookingUpdate/AirBookingUpdate")
);

const CreateBanner = React.lazy(() =>
  import("./pages/Settings/Banner/CreateBanner")
);

const BannerList = React.lazy(() =>
  import("./pages/Settings/Banner/BannerList")
);

const CreateNotice = React.lazy(() =>
  import("./pages/Settings/Notice/CreateNotice")
);

const NoticeList = React.lazy(() =>
  import("./pages/Settings/Notice/NoticeList")
);

const CreateSetting = React.lazy(() =>
  import("./pages/Settings/Setting/CreateSetting")
);

const SettingList = React.lazy(() =>
  import("./pages/Settings/Setting/SettingList")
);

const BookingDetailsCreate = React.lazy(() =>
  import("./pages/AirBooking/BookingDetailsCreate/BookingDetailsCreate")
);

const ZoneCreate = React.lazy(() => import("./pages/Agent/Zone/ZoneCreate"));
const ZoneListTable = React.lazy(() =>
  import("./pages/Agent/Zone/ZoneListTable")
);

const FeaturesList = React.lazy(() =>
  import("./pages/IAM/Features/FeaturesList")
);

const SendSms = React.lazy(() => import("./pages/Promotion/SendSms/SendSms"));

const SmsList = React.lazy(() => import("./pages/Promotion/SendSms/SmsList"));
const SendEmail = React.lazy(() =>
  import("./pages/Promotion/SendEmail/SendEmail")
);

const EmailList = React.lazy(() =>
  import("./pages/Promotion/SendEmail/EmailList")
);

const LoanManagement = React.lazy(() => import("./pages/Loan/LoanManagement"));
const LoanCalculator = React.lazy(() => import("./pages/Loan/Calculator"));
const LoanPartiesCreate = React.lazy(() =>
  import("./pages/Loan/LoanParties/LoanPartiesCreate")
);
const LoanPartiesList = React.lazy(() =>
  import("./pages/Loan/LoanParties/LoanPartiesList")
);
const LoanPartiesDetails = React.lazy(() =>
  import("./pages/Loan/LoanParties/LoanPartiesDetails")
);
const PartyLedger = React.lazy(() =>
  import("./pages/Loan/LoanParties/PartyLedger")
);
const LoanCreate = React.lazy(() => import("./pages/Loan/Loan/LoanCreate"));
const LoanList = React.lazy(() => import("./pages/Loan/Loan/LoanList"));
const LoanDetails = React.lazy(() => import("./pages/Loan/Loan/LoanDetails"));
const LoanDisburseRepayment = React.lazy(() =>
  import("./pages/Loan/LoanTransactions/LoanDisburseRepayment")
);
const LoanTransationLedger = React.lazy(() =>
  import("./pages/Loan/LoanTransactions/LoanTransationLedger")
);

const FinanceModule = React.lazy(() => import("./pages/Finance/Finance"));
const CashReceiptList = React.lazy(() =>
  import("./pages/Finance/CashReceipt/CashReceiptList")
);
const CreateCashReceipt = React.lazy(() =>
  import("./pages/Finance/CashReceipt/CreateCashReceipt")
);

const AssetCreate = React.lazy(() =>
  import("./pages/Finance/Asset/AssetCreate")
);

const AsetList = React.lazy(() => import("./pages/Finance/Asset/AsetList"));

const TransactionModule = React.lazy(() =>
  import("./pages/Transactions/Transactions")
);
const AccountPartyList = React.lazy(() =>
  import("./pages/Transactions/AccountParty/AccountPartyList")
);
const CreateAccountParty = React.lazy(() =>
  import("./pages/Transactions/AccountParty/CreateAccountParty")
);
const IncomeHeadList = React.lazy(() =>
  import("./pages/Transactions/IncomeHead/IncomeHeadList")
);
const CreateIncomeHead = React.lazy(() =>
  import("./pages/Transactions/IncomeHead/CreateIncomeHead")
);
const ExpenseHeadList = React.lazy(() =>
  import("./pages/Transactions/ExpenseHead/ExpenseHeadList")
);
const CreateExpenseHead = React.lazy(() =>
  import("./pages/Transactions/ExpenseHead/CreateExpenseHead")
);

const IncomeList = React.lazy(() =>
  import("./pages/Transactions/Income/IncomeList")
);
const CreateIncome = React.lazy(() =>
  import("./pages/Transactions/Income/CreateIncome")
);
const ExpenseList = React.lazy(() =>
  import("./pages/Transactions/Expense/ExpenseList")
);
const CreateExpense = React.lazy(() =>
  import("./pages/Transactions/Expense/CreateExpense")
);
const AccountTransactions = React.lazy(() =>
  import("./pages/Transactions/Legder/AccountTransactions")
);

const AdditionalChargeList = React.lazy(() =>
  import("./pages/Service/Visa/AdditionalCharge/AdditionalChargeList")
);
const CreateAdditionalCharge = React.lazy(() =>
  import("./pages/Service/Visa/AdditionalCharge/CreateAdditionalCharge")
);

const DepositGatewayFeeList = React.lazy(() =>
  import("./pages/Company/DepositGatewayFee/DepositGatewayFeeList")
);
const CreateDepositGatewayFee = React.lazy(() =>
  import("./pages/Company/DepositGatewayFee/CreateDepositGatewayFee")
);
const Market = React.lazy(() => import("./pages/Market/Market"));

const LoadingIndicator = (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
    }}
  >
    <CircularProgress />
  </Box>
);

function App() {
  return (
    <Box
      style={{
        position: "relative",
      }}
    >
      {/* <Header /> */}
      {/* These decorative shapes are colored for the light background (#EAE8F4
          on #f2f0f9) and are barely visible there by design - in dark mode
          they'd stand out starkly, so they're hidden via the
          "decorative-bg-shape" class (see index.css) instead of recoloring
          each SVG. */}
      <Box
        className="decorative-bg-shape"
        style={{
          position: "absolute",
          top: "20%",
          left: "14%",
          zIndex: "-1",
          transform: "translate(-50%, -50%)",
        }}
      >
        <img src={dot1} />
      </Box>
      <Box
        className="decorative-bg-shape"
        style={{
          position: "absolute",
          top: "13%",
          left: "54%",
          transform: "translate(-50%, -50%)",
          zIndex: "-1",
        }}
      >
        <img src={circle} alt="Circle" />
      </Box>
      <Box
        className="decorative-bg-shape"
        style={{
          position: "absolute",
          top: "-10px",
          right: "15px",
          zIndex: "-1",
        }}
      >
        <img src={ring} />
      </Box>
      <Box
        className="decorative-bg-shape"
        style={{
          position: "absolute",
          bottom: "-3%",
          left: "9%",
          transform: "translate(-2%, -5%)",
          zIndex: "-1",
        }}
      >
        <img src={imageReactangle} alt="imageReactangle" />
      </Box>
      <Box
        className="decorative-bg-shape"
        style={{
          position: "absolute",
          bottom: "-15px",
          right: "180px",
          zIndex: "-1",
        }}
      >
        <img src={dot2} alt="dot2" />
      </Box>

      <ThemeModeProvider>
      <CustomerProvider>
        <BrowserRouter>
          <ToastContainer />
          <React.Suspense fallback={LoadingIndicator}>
            <Routes>
              <Route path="/" element={<Login />} />

              <Route
                path="/vendortablelistfilter"
                element={<VendorTableListFilter />}
              />
              <Route
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <DashboardSidebar />
                  </PrivateRoute>
                }
              >
                <Route path="/dashboard/admin" element={<AdminDashboard />} />

                {/* Profile */}
                <Route path="/dashboard/profile" element={<Profile />} />

                {/* Vendor Ledger */}
                <Route
                  path="/dashboard/vendor-account-ledger"
                  element={<VendorAccountLedger />}
                />
                <Route
                  path="/dashboard/hajj-package-ledger"
                  element={<HajjPackageLedger />}
                />

                {/* Company Account Ledger */}
                <Route
                  path="/dashboard/company-account-ledger"
                  element={<CompanyAccountLedgerTable />}
                />

                {/* Company Central Account Ledger */}
                <Route
                  path="/dashboard/company-central-account-ledger"
                  element={<CompanyCentralAccount />}
                />
                <Route
                  path="/dashboard/company-central-account-ledger/insights"
                  element={<CompanyCentralAccountInsights />}
                />
                <Route
                  path="/dashboard/bank-cheque-history-create/:id"
                  element={<BankChequeHistoryCreate />}
                />
                <Route
                  path="/dashboard/bank-cheque-list"
                  element={<ChequeListTable />}
                />

                <Route
                  path="/dashboard/transactions-list"
                  element={<Transactions />}
                />
                {/* Traveller */}
                <Route
                  path="/dashboard/create-traveller/:id"
                  element={<TravellerCreate />}
                />

                <Route
                  path="/dashboard/traveller-list"
                  element={<TravellerListTable />}
                />

                {/* Agent Account Ledger */}
                <Route
                  path="/dashboard/agent-account-ledger"
                  element={<AgentAccountLedger />}
                />

                <Route
                  path="/dashboard/agent-general-ledger"
                  element={<AgentGaneralLedger />}
                />

                {/* Customer Ledger */}
                <Route
                  path="/dashboard/customer-account-ledger"
                  element={<CustomerAccountLedger />}
                />



                {/* CompanyBankListTable */}

                <Route
                  path="/dashboard/company-bank-list"
                  element={<CompanyBankListTable />}
                />

                <Route
                  path="/dashboard/company-receipt-copy"
                  element={<ReceiptCopy />}
                />
                <Route
                  path="/dashboard/company-expense-table"
                  element={<CompanyExpenseTable />}
                />

                {/* User Loggedin */}

                <Route
                  path="/dashboard/user-activity-list-table"
                  element={<UserActivityListTable />}
                />
                <Route
                  path="/dashboard/user-login-activity-list"
                  element={<UserLoginActivity />}
                />
                <Route
                  path="/dashboard/resposibility-list"
                  element={<ResponsibilityListTable />}
                />

                {/* User Activity */}
                <Route
                  path="/dashboard/user-loggedin-list-table"
                  element={<UserLoginDeviceListTable />}
                />

                <Route
                  path="/dashboard/air-search-log/:id"
                  element={<AirSearchLog />}
                />

                {/* Selllement */}
                <Route
                  path="/dashboard/refund-settle"
                  element={<RefundSettlement />}
                />
                <Route
                  path="/dashboard/void-settle"
                  element={<VoidSettlement />}
                />
                <Route
                  path="/dashboard/ticket-settle"
                  element={<TicketSettlement />}
                />

                <Route
                  path="/dashboard/refund-detail/:id"
                  element={<RefundDetail />}
                />

                <Route
                  path="/dashboard/reissue-detail/:id"
                  element={<ReissueDetail />}
                />
                <Route
                  path="/dashboard/reissue-vendor-charge"
                  element={<VendorChargeSection />}
                />

                <Route
                  path="/dashboard/reissue-fare-breakdown/:id"
                  element={<ReissueFareBreakdown />}
                />

                <Route
                  path="/dashboard/ssr-detail/:id"
                  element={<SsrDetail />}
                />

                <Route
                  path="/dashboard/void-detail/:id"
                  element={<VoidDetail />}
                />

                <Route
                  path="/dashboard/booking-detail-update/:id"
                  element={<BookingDetailsUpdate />}
                />
                {/* Card Menu */}
                <Route
                  path="/dashboard/airbooking/:id"
                  element={<AirBookingInfo />}
                />

                <Route
                  path="/dashboard/airbooking-details/:id"
                  element={<AirBookingDetails />}
                />

                <Route
                  path="/dashboard/airbooking-update/:id"
                  element={<AirBookingUpdate />}
                />
                {/* Vendor Booking */}
                <Route
                  path="/dashboard/vendor-booking-chart"
                  element={<VendorBookingsDetailsChart />}
                />

                {/* Vendor Booking Tab */}
                <Route path="/dashboard/vendor-void" element={<VendorVoid />} />

                <Route
                  path="/dashboard/vendor-booking-list-table"
                  element={<VendorBookingListTable />}
                />

                {/* Air Booking */}
                <Route
                  path="/dashboard/airbooking-list-table"
                  element={<AirBookingListTable />}
                />

                {/* Passenger Segment Flown Status */}
                <Route
                  path="/dashboard/passenger-segment-flown-status"
                  element={<PassengerSegmentFlownStatus />}
                />

                <Route
                  path="/dashboard/booking-details-create"
                  element={<BookingDetailsCreate />}
                />

                {/* Agent Booking */}
                <Route
                  path="/dashboard/agent-booking-chart"
                  element={<AgentBookingsDetailsChart />}
                />

                <Route
                  path="/dashboard/agent-booking-list-table"
                  element={<AgentBookingListTable />}
                />

                {/* Customer Booking */}
                <Route
                  path="/dashboard/custome-booking-chart"
                  element={<CustomerBookingsDetailsChart />}
                />

                <Route
                  path="/dashboard/customer-booking-list-table"
                  element={<CustomerBookingListTable />}
                />

                <Route
                  path="/dashboard/vendor-list"
                  element={<VendorListTable />}
                />
                <Route
                  path="/dashboard/vendor-details"
                  element={<VendorDetail />}
                />

                <Route
                  path="/dashboard/customer-list"
                  element={<CustomerListTable />}
                />

                <Route path="/dashboard/service" element={<Service />} />
                <Route
                  path="/dashboard/hajj-package-create/:id"
                  element={<CreateHajjPackage />}
                />

                <Route
                  path="/dashboard/hajj-package-list"
                  element={<HajjPackageList />}
                />

                <Route path="/dashboard/visa" element={<Visa />} />
                <Route
                  path="/dashboard/visa-category-create/:id"
                  element={<VisaCategroyCreate />}
                />

                <Route
                  path="/dashboard/visa-category-list"
                  element={<VisaCategoryList />}
                />
                <Route
                  path="/dashboard/visa-package-create/:id"
                  element={<VisaPackageCreate />}
                />
                <Route
                  path="/dashboard/visa-faq-create"
                  element={<VisaFaqCreate />}
                />
                <Route
                  path="/dashboard/visa-faq-create/:id"
                  element={<VisaFaqCreate />}
                />

                <Route
                  path="/dashboard/visa-faq-list"
                  element={<VisaFaqList />}
                />
                <Route
                  path="/dashboard/visa-package-order-create/:id"
                  element={<VisaPackageOrderCreate />}
                />
                <Route
                  path="/dashboard/visa-package-order-list"
                  element={<VisaPackageOrderList />}
                />
                <Route
                  path="/dashboard/visa-package-order-details/:id"
                  element={<VisaPackageOrderDeatils />}
                />
                <Route
                  path="/dashboard/visa-package-update/:id"
                  element={<VisaUpdate />}
                />
                <Route
                  path="/dashboard/visa-package-list"
                  element={<VisaPackageList />}
                />

                <Route path="/dashboard/inventory" element={<Inventory />} />

                <Route
                  path="/dashboard/product-category-create/:id"
                  element={<ProductCategoryCreate />}
                />

                <Route
                  path="/dashboard/product-category-list"
                  element={<ProductCategoryList />}
                />

                <Route
                  path="/dashboard/product-create/:id"
                  element={<ProductsCreate />}
                />
                <Route
                  path="/dashboard/products-list"
                  element={<ProductsList />}
                />

                <Route
                  path="/dashboard/all-order-list"
                  element={<OrdersListTable />}
                />

                <Route
                  path="/dashboard/order-details/:id"
                  element={<OrderDetails />}
                />

                <Route
                  path="/dashboard/api-sale-details/:id"
                  element={<ApiOrderDetails />}
                />

                <Route
                  path="/dashboard/purchase-create/:id"
                  element={<PurchaseCreate />}
                />

                <Route
                  path="/dashboard/purchase-list"
                  element={<PurchaseList />}
                />

                <Route
                  path="/dashboard/sale-create/:id"
                  element={<SaleCreate />}
                />

                <Route path="/dashboard/sale-list" element={<SaleList />} />

                <Route
                  path="/dashboard/quotation-create/:id"
                  element={<QuotationCreate />}
                />

                <Route
                  path="/dashboard/quotation-list"
                  element={<QuotationList />}
                />

                <Route
                  path="/dashboard/sale-return-create/:id"
                  element={<SaleReturn />}
                />

                <Route
                  path="/dashboard/sale-return-list"
                  element={<SaleReturnList />}
                />

                <Route path="/dashboard/remote/sale" element={<RemoteSale />} />

                <Route
                  path="/dashboard/suscription-create/:id"
                  element={<SuscriptionCreate />}
                />

                <Route
                  path="/dashboard/suscription-list"
                  element={<SuscriptionList />}
                />

                <Route
                  path="/dashboard/hotel-create/:id"
                  element={<HotelCreate />}
                />
                <Route
                  path="/dashboard/hotel-list"
                  element={<HotelListTable />}
                />
                <Route
                  path="/dashboard/hotel-details/:id"
                  element={<HotelDetails />}
                />
                <Route
                  path="/dashboard/hotel-booking-update/:id"
                  element={<HotelBookingUpdate />}
                />
                <Route
                  path="/dashboard/agent-list"
                  element={<AgentListTable />}
                />

                <Route
                  path="/dashboard/agent-details/:agentId"
                  element={<AgentDetails />}
                />

                <Route
                  path="/dashboard/customer-details"
                  element={<CustomerDetails />}
                />

                <Route path="/dashboard/vendoradd" element={<CreateVendor />} />
                <Route
                  path="/dashboard/createagent"
                  element={<CreateAgent />}
                />

                <Route
                  path="/dashboard/customeradd"
                  element={<CreateCustomer />}
                />

                <Route path="/dashboard/create/adm" element={<CreateAdm />} />
                <Route
                  path="/dashboard/create/adm/:id"
                  element={<CreateAdm />}
                />

                <Route path="/dashboard/adm/list" element={<AdmList />} />
                {/*  vendor route */}
                <Route path="/dashboard/vendornav" element={<VendorNav />}>
                  <Route
                    path="/dashboard/vendornav/basicinfo"
                    element={<VendorBasicInfo />}
                  />
                  <Route
                    path="/dashboard/vendornav/service"
                    element={<VendorService />}
                  />

                  <Route
                    path="/dashboard/vendornav/vendor-account"
                    element={<VendorAccount />}
                  />
                  <Route
                    path="/dashboard/vendornav/vendor-contact"
                    element={<VendorContactInfo />}
                  />

                  <Route
                    path="/dashboard/vendornav/vendor-register"
                    element={<VendorRegister />}
                  />

                  <Route
                    path="/dashboard/vendornav/other"
                    element={<AccountContactInfo />}
                  />
                </Route>

                {/* Agent route */}

                <Route path="/dashboard/agentnav" element={<AgentNav />}>
                  <Route
                    path="/dashboard/agentnav/agentbasicinfo"
                    element={<AgentBasicInfo />}
                  />
                  <Route path="/dashboard/agentnav/user" element={<User />} />
                  <Route
                    path="/dashboard/agentnav/documents"
                    element={<AgentDocuments />}
                  />

                  <Route
                    path="/dashboard/agentnav/accounts"
                    element={<AgentAccount />}
                  />
                  <Route
                    path="/dashboard/agentnav/register"
                    element={<AgentRegister />}
                  />

                  <Route
                    path="/dashboard/agentnav/assign"
                    element={<FeatureAssign />}
                  />
                  <Route path="api/access/key" element={<ApiAccessKey />} />
                  <Route path="api/access/key/:id" element={<ApiAccessKey />} />
                </Route>

                <Route
                  path="/dashboard/agentnav/api/access/key-list/:id"
                  element={<ApiAccessKeyList />}
                />
                {/* Zone */}
                <Route
                  path="/dashboard/createzone/:zoneId"
                  element={<ZoneCreate />}
                />
                <Route path="/dashboard/zonelist" element={<ZoneListTable />} />

                {/* Customer Route */}
                <Route path="/dashboard/customernav" element={<CustomerNav />}>
                  <Route
                    path="/dashboard/customernav/customerbasicinfo"
                    element={<CustomerBasicInfo />}
                  />

                  <Route
                    path="/dashboard/customernav/customeraccounts"
                    element={<CustomerAccounts />}
                  />

                  <Route
                    path="/dashboard/customernav/customerregister"
                    element={<CustomerRegister />}
                  />
                </Route>

                {/*  vendor balance route */}

                <Route
                  path="/dashboard/vendorbalancenav/:id"
                  element={<VendorBalanceNav />}
                />

                {/* Customer Balance Route */}
                <Route
                  path="/dashboard/customerbalancenav/:id"
                  element={<CustomerAccountNav />}
                />

                {/* Agent Balance Route */}
                <Route
                  path="/dashboard/agentbalancenav/:id"
                  element={<AgentAccountNav />}
                />

                {/* Company Balance Route */}
                <Route
                  path="/dashboard/companybalancenav"
                  element={<CompanyAccountNav />}
                >
                  <Route
                    path="/dashboard/companybalancenav/balance-add"
                    element={<CompanyBalanceAdd />}
                  />
                  <Route
                    path="/dashboard/companybalancenav/balance-deduct"
                    element={<CompanyBalanceDeduct />}
                  />
                  <Route
                    path="/dashboard/companybalancenav/balance-transfer"
                    element={<CompanyBalanceTransfer />}
                  />
                </Route>
                <Route
                  path="/dashboard/create-company-account/:id"
                  element={<CreateCompanyAccount />}
                />
                {/* Settings */}
                <Route path="/dashboard/setting" element={<Setting />} />

                <Route path="/dashboard/others" element={<Others />} />

                <Route path="/dashboard/gds/command" element={<GdsCommand />} />

                <Route path="/dashboard/reports" element={<Reports />} />
                <Route
                  path="/dashboard/company-report"
                  element={<TotalSell />}
                />

                <Route path="/dashboard/zone-report" element={<ZoneReport />} />
                <Route
                  path="/dashboard/agent-list-report"
                  element={<AgentListReport />}
                />
                <Route
                  path="/dashboard/airline-statistics"
                  element={<AirlineReport />}
                />
                <Route
                  path="/dashboard/venodr-airline-statistics"
                  element={<VendorAirlineReport />}
                />

                <Route
                  path="/dashboard/agent-statistics/:id"
                  element={<AgentStatisticsReport />}
                />
                <Route
                  path="/dashboard/currency-list"
                  element={<CurrencyList />}
                />
                <Route
                  path="/dashboard/create-currency/:id"
                  element={<CreateCurrency />}
                />
                <Route
                  path="/dashboard/currency-change-log"
                  element={<CurrencyChangeLogList />}
                />
                <Route
                  path="/dashboard/currency-change-log/:id"
                  element={<CurrencyChangeLogList />}
                />
                <Route
                  path="/dashboard/deposit-request-list/:id"
                  element={<DepositRequestList />}
                />
                <Route
                  path="/dashboard/create-deposit-request"
                  element={<CreateDepositRequest />}
                />
                <Route
                  path="/dashboard/credit-request-list/:id"
                  element={<CreditRequestList />}
                />
                <Route
                  path="/dashboard/credit-module-nav"
                  element={<CreditManagementListTable />}
                />
                <Route
                  path="/dashboard/currency-list"
                  element={<CurrencyList />}
                />
                <Route
                  path="/dashboard/create-currency/:id"
                  element={<CreateCurrency />}
                />
                <Route
                  path="/dashboard/currency-change-log"
                  element={<CurrencyChangeLogList />}
                />
                <Route
                  path="/dashboard/currency-change-log/:id"
                  element={<CurrencyChangeLogList />}
                />
                <Route
                  path="/dashboard/deposit-request-list"
                  element={<DepositRequestList />}
                />
                <Route
                  path="/dashboard/api-provider-list"
                  element={<ApiProviderList />}
                />
                <Route
                  path="/dashboard/create-api-provider/:id"
                  element={<CreateApiProvider />}
                />
                <Route path="/dashboard/prmotion" element={<Promotion />} />
                <Route
                  path="/dashboard/smstemplate/:id"
                  element={<SmsTemplate />}
                />
                <Route
                  path="/dashboard/sms-template-list"
                  element={<SmsTemplateList />}
                />
                <Route
                  path="/dashboard/emailtemplate/:id"
                  element={<EmailTemplate />}
                />
                <Route
                  path="/dashboard/email-template-list"
                  element={<EmailTemplateList />}
                />
                <Route path="/dashboard/market" element={<Market />} />
                <Route
                  path="/dashboard/user-hotel-markup-commission-list"
                  element={<UserHotelMarkupCommissionList />}
                />
                <Route
                  path="/dashboard/create-hotel-user-markup-commission/:id"
                  element={<CreateUserHotelMarkupCommission />}
                />
                <Route
                  path="/dashboard/create-product-markup-commission/:id"
                  element={<ApiMarkupCommission />}
                />
                <Route
                  path="/dashboard/product-commission-list"
                  element={<ApiMarkupCommissionList />}
                />
                <Route
                  path="/dashboard/user-flight-markup-commission-list"
                  element={<UserMarkupCommissionList />}
                />
                <Route
                  path="/dashboard/create-flight-user-markup-commission/:id"
                  element={<CreateUserMarkupCommission />}
                />
                <Route
                  path="/dashboard/create-airline-brand-markup-commission/:id"
                  element={<CreateAirlineBrandMarkupCommission />}
                />
                <Route
                  path="/dashboard/airline-brand-markup-commission-list"
                  element={<AirlineBrandMarkupCommissionList />}
                />
                <Route
                  path="/dashboard/vendor-markup-commission-list"
                  element={<VendorMarkupCommissionList />}
                />
                <Route
                  path="/dashboard/create-vendor-markup-commission/:id"
                  element={<CreateVendorMarkupCommission />}
                />
                <Route
                  path="/dashboard/airline-blocking-list"
                  element={<AirlineBlockingList />}
                />
                <Route
                  path="/dashboard/create-airline-blocking/:id"
                  element={<CreateAirlineBlocking />}
                />
                <Route
                  path="/dashboard/promo-code-list"
                  element={<PromoCodeList />}
                />
                <Route
                  path="/dashboard/create-promo-code/:code"
                  element={<CreatePromoCode />}
                />
                <Route
                  path="/dashboard/department-list"
                  element={<DepartmentList />}
                />
                <Route
                  path="/dashboard/create-airline-routing/:id"
                  element={<AirlineRoutingCreate />}
                />

                <Route
                  path="/dashboard/airline-routing-list"
                  element={<AirlineRoutinglist />}
                />

                <Route
                  path="/dashboard/create-department/:id"
                  element={<CreateDepartment />}
                />
                <Route
                  path="/dashboard/designation-list"
                  element={<DesignationList />}
                />
                <Route
                  path="/dashboard/create-designation/:id"
                  element={<CreateDesignation />}
                />
                <Route
                  path="/dashboard/employee-list"
                  element={<EmployeeList />}
                />
                <Route
                  path="/dashboard/create-employee/:id"
                  element={<CreateEmployee />}
                />
                <Route path="/dashboard/role-list" element={<RoleList />} />
                <Route
                  path="/dashboard/create-role/:id"
                  element={<CreateRole />}
                />
                <Route
                  path="/dashboard/airline-list"
                  element={<AirlineList />}
                />
                <Route
                  path="/dashboard/create-airline/:id"
                  element={<CreateAirline />}
                />
                <Route
                  path="/dashboard/airport-list"
                  element={<AirportList />}
                />
                <Route
                  path="/dashboard/create-airport/:id"
                  element={<CreateAirport />}
                />
                <Route
                  path="/dashboard/user-task-list"
                  element={<UserTaskList />}
                />
                <Route
                  path="/dashboard/user-task-list-me"
                  element={<UserTaskListMe />}
                />
                <Route
                  path="/dashboard/create-user-task/:id"
                  element={<CreateUserTask />}
                />
                <Route
                  path="/dashboard/update-user-task-me/:id"
                  element={<UpdateUserTaskMe />}
                />
                <Route path="/dashboard/banner-list" element={<BannerList />} />
                <Route
                  path="/dashboard/create-banner/:id"
                  element={<CreateBanner />}
                />
                <Route path="/dashboard/notice-list" element={<NoticeList />} />
                <Route
                  path="/dashboard/create-notice/:id"
                  element={<CreateNotice />}
                />
                <Route
                  path="/dashboard/setting-list"
                  element={<SettingList />}
                />
                <Route
                  path="/dashboard/create-setting/:id"
                  element={<CreateSetting />}
                />
                <Route
                  path="/dashboard/segment-report"
                  element={<SegmentCount />}
                />
                <Route
                  path="/dashboard/features-list"
                  element={<FeaturesList />}
                />
                <Route path="/dashboard/send-sms" element={<SendSms />} />
                <Route path="/dashboard/sms-list" element={<SmsList />} />
                <Route path="/dashboard/send-email" element={<SendEmail />} />
                <Route path="/dashboard/email-list" element={<EmailList />} />

                <Route
                  path="/dashboard/loan-management"
                  element={<LoanManagement />}
                />
                <Route
                  path="/dashboard/loan-calculator"
                  element={<LoanCalculator />}
                />
                <Route
                  path="/dashboard/loan-parties-create/:id"
                  element={<LoanPartiesCreate />}
                />
                <Route
                  path="/dashboard/loan-parties-list"
                  element={<LoanPartiesList />}
                />
                <Route
                  path="/dashboard/loan-parties-details/:id"
                  element={<LoanPartiesDetails />}
                />
                <Route
                  path="/dashboard/loan-party-ledger"
                  element={<PartyLedger />}
                />
                <Route
                  path="/dashboard/loan-create/:id"
                  element={<LoanCreate />}
                />
                <Route path="/dashboard/loan-list" element={<LoanList />} />
                <Route
                  path="/dashboard/loan-details/:id"
                  element={<LoanDetails />}
                />
                <Route
                  path="/dashboard/loandisburse-repayment"
                  element={<LoanDisburseRepayment />}
                />
                <Route
                  path="/dashboard/loan/transation-ledger"
                  element={<LoanTransationLedger />}
                />
                <Route path="/dashboard/finance" element={<FinanceModule />} />

                <Route
                  path="/dashboard/finance/create-cash-receipt/:id"
                  element={<CreateCashReceipt />}
                />
                <Route
                  path="/dashboard/finance/cash-receipts"
                  element={<CashReceiptList />}
                />

                <Route
                  path="/dashboard/assets/create/:id"
                  element={<AssetCreate />}
                />

                <Route path="/dashboard/asets/list" element={<AsetList />} />

                <Route
                  path="/dashboard/transactions"
                  element={<TransactionModule />}
                />

                <Route
                  path="/dashboard/transactions/create-account-party/:id"
                  element={<CreateAccountParty />}
                />
                <Route
                  path="/dashboard/transactions/account-parties"
                  element={<AccountPartyList />}
                />
                <Route
                  path="/dashboard/transactions/create-receipt-head/:id"
                  element={<CreateIncomeHead />}
                />

                <Route
                  path="/dashboard/transactions/receipt-heads"
                  element={<IncomeHeadList />}
                />

                <Route
                  path="/dashboard/transactions/create-offline-service/:id"
                  element={<CreateOfflineService />}
                />

                <Route
                  path="/dashboard/transactions/offline-services"
                  element={<OfflineServiceList />}
                />

                <Route
                  path="/dashboard/transactions/create-payment-head/:id"
                  element={<CreateExpenseHead />}
                />

                <Route
                  path="/dashboard/transactions/payment-heads"
                  element={<ExpenseHeadList />}
                />

                <Route
                  path="/dashboard/transactions/create-receipt"
                  element={<CreateIncome />}
                />

                <Route
                  path="/dashboard/transactions/receipts"
                  element={<IncomeList />}
                />
                <Route
                  path="/dashboard/transactions/create-payment"
                  element={<CreateExpense />}
                />

                <Route
                  path="/dashboard/transactions/payments"
                  element={<ExpenseList />}
                />
                <Route
                  path="/dashboard/transactions/ledger"
                  element={<AccountTransactions />}
                />

                <Route
                  path="/dashboard/additional-charge/:id"
                  element={<CreateAdditionalCharge />}
                />
                <Route
                  path="/dashboard/additional-charges"
                  element={<AdditionalChargeList />}
                />

                <Route
                  path="/dashboard/user-deposit-gateway-fee-create/:id"
                  element={<CreateDepositGatewayFee />}
                />

                <Route
                  path="/dashboard/user-deposit-gateway-fees"
                  element={<DepositGatewayFeeList />}
                />
              </Route>
            </Routes>
          </React.Suspense>
        </BrowserRouter>
      </CustomerProvider>
      </ThemeModeProvider>
    </Box>
  );
}

export default App;
